import Box from "@mui/material/Box";
import Button from "../../../../components/Buttons/Button";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  BUTTON_EDIT_BUDGET,
  BUTTON_PUBLISH_CAMPAIGN,
  BUTTON_SAVE_AND_PUBLISH,
  BUTTON_SAVE_CHANGES,
  CAMPAIGN_ALREADY_BEING_CREATED,
  CAMPAIGN_ALREADY_BEING_UPDATED,
  ERROR_PROCESSING_CAMPAIGNS,
  PUBLISHING_ALERT_ERROR_TITLE,
  PUBLISHING_ALERT_SUCCESS_TITLE,
  PUBLISHING_ALERT_TITLE,
  BUTTON_GO_BACK,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION,
  CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE,
} from "../../../../i18n/keysTranslations";
import { useFormContext } from "react-hook-form";
import {
  getCampaignUpdatedByStatus,
  getPreviewAlertBudgets,
} from "../../../../services/adsCampaigns";
import {
  startCreateAdsCampaign,
  startSaveAdsCampaign,
  checkAndAddPublishingCampaign,
  checkAndShowNpsForm,
  startSaveDraftCampaign,
} from "../../../../actions/adsCampaigns";
import { useDispatchApp, useSelectorApp } from "../../../../lib/redux";
import {
  ConfirmAlert,
  SimpleAlert,
} from "../../../../components/Alerts/Alerts";
import { useRef, useState } from "react";
import {
  ADS_CAMPAIGN_ACTION_STATUS,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ALERT_ICON_TYPE_SUCCESS,
  ALERTS_ASYNC_STATUS,
  NPS_RATING_ACTION_PUBLISH,
  ADVERTISERS_DEMO,
} from "../../../../utils/constants";
import {
  getIntegrationKey,
  getRoleCapability,
} from "../../../../actions/getters";
import ContainerBudgetAlert from "../../../../components/Containers/ContainerBudgetAlert";
import ModalConnectAccounts from "../../../../components/Modal/ModalConnectAccounts";
import { startValidateYoutubeVideos } from "../../../../actions/user";
import { keyframes } from "@emotion/react";
import { waitDelay } from "../../../../utils/date";
import i18next from "i18next";
import { useEffect } from "react";

import { INPUT_COLOR_BORDER } from "../../../../utils/colors";
import { getYoutubeVideoValidationErrorMessage } from "../../../../utils/youtubeVideoValidation";
import {
  removeNotification,
  updateNotification,
} from "../../../../actions/alerts";

const translationActionStatusMap = {
  [ADS_CAMPAIGN_ACTION_STATUS.creating]: i18next.t(
    CAMPAIGN_ALREADY_BEING_CREATED
  ),
  [ADS_CAMPAIGN_ACTION_STATUS.updating]: i18next.t(
    CAMPAIGN_ALREADY_BEING_UPDATED
  ),
};

const BottomBar = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [modalConnectAccountsOpen, setModalConnectAccountsOpen] =
    useState(false);
  const [isValidatingIfNeedRenderMedia] = useState(false);
  const [isValidatingYoutube, setIsValidatingYoutube] = useState(false);
  const lastCampaignActionStatus = useRef();
  const thisPageInitiatedActionRef = useRef(false);

  const dispatch = useDispatchApp();
  const { t } = useTranslationApp();
  const {
    campaignID,
    getValues,
    setValue,
    watch,
    trigger,
    setError,
    isGenerating,
    isUpdating,
    hasSomePlatformDraft,
    onChangeIsUpdating,
    isGeneralCampaignIncompatible,
    formState: { errors, isDirty },
    onChangeIsForcedSetupPage,
    onChangeSectionSelected,
    sectionSelected,
    reset,
    isSyncingData,
    campaignActionStatus,
    campaignApproval,
    onSaveAdsCampaignDraftWithApproval,
  } = useFormContext();

  const isCampaignExecutingAction = Boolean(campaignActionStatus);
  const canEditCampaign = dispatch(getRoleCapability("canEditCampaign"));

  const onClearPreloadedChatAndDeleteReport = async () => {
    // Fix delete optimizations after save
    // clearPreloadedChatMessagesRef?.current?.();
    // await dispatch(startDeleteCampaignReport({ campaignID }));
    // setValue("report", {});
  };
  const integrations = useSelectorApp((state) => state.user.integrations);
  const notifications = useSelectorApp(
    (state) => state.alerts?.notifications || []
  );
  const platforms = watch("platforms");
  const advertiserID = useSelectorApp(
    (state) => state.auth?.user?.advertiserID
  );
  const isDemoAdvertiser = ADVERTISERS_DEMO.includes(advertiserID);

  const confirmPublishWithoutApproval = async (
    confirmButtonKey = BUTTON_PUBLISH_CAMPAIGN
  ) => {
    if (!campaignApproval?.enabled || campaignApproval?.status === "approved") {
      return true;
    }

    const result = await ConfirmAlert({
      title: t(CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_TITLE),
      text: t(CAMPAIGN_APPROVAL_PUBLISH_NOT_APPROVED_DESCRIPTION),
      confirmButtonText: t(BUTTON_GO_BACK),
      cancelButtonText: t(confirmButtonKey),
    });

    return result.isDismissed === true && result.dismiss === "cancel";
  };

  const translationActionStatus =
    translationActionStatusMap[campaignActionStatus];
  const tooltipActionStatus = campaignActionStatus
    ? translationActionStatus
    : null;

  const findFirstErrorIndex = (errors) => {
    let result = {
      platform: null,
      adGroupID: null,
      adID: null,
      assetsGroupID: null,
    };

    const searchErrors = (obj, path = []) => {
      if (!obj || typeof obj !== "object") return false;

      if (obj.platformsData) {
        const platformWithError = Object.keys(obj.platformsData)[0];
        if (platformWithError) {
          result.platform = platformWithError;
          return true;
        }
      }

      if (obj.assetsGroups) {
        const assetsGroupIdx = obj.assetsGroups.findIndex((group) => group);
        if (assetsGroupIdx !== -1) {
          const values = getValues();
          result.assetsGroupID = values?.assetsGroups?.[assetsGroupIdx]?.id;
          result.platform = values?.assetsGroups?.[assetsGroupIdx]?.platform;
          return true;
        }
      }

      if (obj.adsGroups) {
        const adGroupIdx = obj.adsGroups.findIndex((group, idx) => {
          if (!group) return false;

          if (Object.keys(group).some((key) => key !== "ads")) {
            const values = getValues();
            result.platform = values?.adsGroups?.[idx]?.platform;
            result.adGroupID = values?.adsGroups?.[idx]?.id;
            return true;
          }

          if (group.ads) {
            const adIdx = group.ads.findIndex((ad) => ad);
            if (adIdx !== -1) {
              const values = getValues();
              result.platform = values?.adsGroups?.[idx]?.platform;
              result.adGroupID = values?.adsGroups?.[idx]?.id;
              result.adID = values?.adsGroups?.[idx]?.ads?.[adIdx]?.id;
              return true;
            }
          }
          return false;
        });

        if (adGroupIdx !== -1) return true;
      }

      return Object.entries(obj).some(([key, value]) => {
        return searchErrors(value, [...path, key]);
      });
    };

    searchErrors(errors);
    return result;
  };

  const extractAllYoutubeUrls = (campaign) => {
    const urlMap = new Map(); // url -> [{ type: 'assetsGroup'|'adGroup', index, videoIndex }]
    const assetsGroups = campaign?.assetsGroups || [];
    const adsGroups = campaign?.adsGroups || [];

    // Extraer URLs de assetsGroups (implementación existente)
    assetsGroups.forEach((assetsGroup, assetsGroupIndex) => {
      const videoUrls = assetsGroup?.videoUrls || [];
      videoUrls.forEach((url, videoIndex) => {
        if (url && url.trim() !== "") {
          const normalizedUrl = url.trim();
          if (!urlMap.has(normalizedUrl)) {
            urlMap.set(normalizedUrl, []);
          }
          urlMap.get(normalizedUrl).push({
            type: "assetsGroup",
            index: assetsGroupIndex,
            videoIndex,
          });
        }
      });
    });

    // Extraer URLs de adsGroups (nueva implementación)
    adsGroups.forEach((adGroup, adGroupIndex) => {
      const videoUrls = adGroup?.videoUrls || [];
      videoUrls.forEach((url, videoIndex) => {
        if (url && url.trim() !== "") {
          const normalizedUrl = url.trim();
          if (!urlMap.has(normalizedUrl)) {
            urlMap.set(normalizedUrl, []);
          }
          urlMap.get(normalizedUrl).push({
            type: "adGroup",
            index: adGroupIndex,
            videoIndex,
          });
        }
      });
    });

    return {
      uniqueUrls: Array.from(urlMap.keys()),
      urlMap,
    };
  };

  const setYoutubeUrlErrors = (invalidUrls, urlMap) => {
    invalidUrls.forEach((invalidUrl) => {
      const { url, isPublic, isDurationValid } = invalidUrl;
      const locations = urlMap.get(url.trim());

      if (locations) {
        const errorMessage = getYoutubeVideoValidationErrorMessage({
          isPublic,
          isDurationValid,
          t,
        });

        if (errorMessage) {
          locations.forEach((location) => {
            const { type, index, videoIndex } = location;

            let errorPath;
            if (type === "assetsGroup") {
              errorPath = `assetsGroups.[${index}].videoUrls.[${videoIndex}]`;
            } else if (type === "adGroup") {
              errorPath = `adsGroups.[${index}].videoUrls.[${videoIndex}]`;
            }

            if (errorPath) {
              setError(errorPath, {
                type: "validation",
                message: errorMessage,
              });
            }
          });
        }
      }
    });
  };

  const validateYoutubeUrls = async () => {
    const campaign = getValues();
    const { uniqueUrls, urlMap } = extractAllYoutubeUrls(campaign);

    if (uniqueUrls.length === 0) {
      return true;
    }

    try {
      const response = await dispatch(startValidateYoutubeVideos(uniqueUrls));

      if (response?.ok === false && response?.invalidUrls) {
        setYoutubeUrlErrors(response.invalidUrls, urlMap);
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error validating YouTube URLs:", error);
      return true;
    }
  };

  const onSaveDraftCampaign = async (e, withAlertSave = true) => {
    const campaign = getValues();
    setIsSaving(true);
    onChangeIsUpdating(true);
    const response = await onSaveAdsCampaignDraftWithApproval({
      campaign,
      campaignID,
    });
    setIsSaving(false);
    onChangeIsUpdating(false);
    if (response) {
      reset(getValues());
      if (withAlertSave) {
        SimpleAlert({
          title: t(ADS_CAMPAIGN_HAS_BEEN_SAVE),
          icon: ALERT_ICON_TYPE_SUCCESS,
        });
      }
    }
  };
  const onCreateCampaign = async (e, withAlertBudget = true) => {
    let showModalConnectAccounts = false;

    platforms.forEach((platform) => {
      const integrationKey = getIntegrationKey(platform, true);

      if (!integrations[integrationKey]) {
        showModalConnectAccounts = true;
      }
    });

    if (showModalConnectAccounts) {
      setModalConnectAccountsOpen(true);
      return;
    }

    const isValidGlobal = await trigger();

    if (!isValidGlobal) {
      const errorIndexes = findFirstErrorIndex(errors);

      if (errorIndexes.platform) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          adGroupID: errorIndexes.adGroupID,
          adID: errorIndexes.adID,
          assetsGroupID: errorIndexes.assetsGroupID,
        });
      }

      if (errors.language || errors.locations) {
        onChangeIsForcedSetupPage(true);
        onChangeSectionSelected({
          platform: undefined,
          adGroupID: undefined,
          adID: undefined,
          from: "addPlatforms",
        });
      }
      return;
    }

    // Validar URLs de YouTube inmediatamente después del trigger
    setIsValidatingYoutube(true);
    let areYoutubeUrlsValid = true;
    try {
      areYoutubeUrlsValid = await validateYoutubeUrls();
    } finally {
      setIsValidatingYoutube(false);
    }
    if (!areYoutubeUrlsValid) {
      const errorIndexes = findFirstErrorIndex(errors);
      if (errorIndexes.assetsGroupID) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          assetsGroupID: errorIndexes.assetsGroupID,
        });
      } else if (errorIndexes.adGroupID) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          adGroupID: errorIndexes.adGroupID,
        });
      }
      return;
    }
    const data = getValues();

    const canPublish = await confirmPublishWithoutApproval();
    if (!canPublish) {
      return;
    }

    if (withAlertBudget) {
      const result = await ConfirmAlert({
        confirmButtonText: t(BUTTON_PUBLISH_CAMPAIGN),
        cancelButtonText: t(BUTTON_EDIT_BUDGET),
        html: (
          <ContainerBudgetAlert
            campaign={data}
            dispatch={dispatch}
            mode="create"
          />
        ),
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    let statusCampaign = ADS_CAMPAIGN_STATUS_ACTIVE;

    dispatch(
      checkAndAddPublishingCampaign({
        campaignID,
        isCreating: true,
        status: ALERTS_ASYNC_STATUS.LOADING,
        message: t(PUBLISHING_ALERT_TITLE),
        progress: 0,
        currentCampaign: getValues(),
        buttonAction: BUTTON_PUBLISH_CAMPAIGN,
      })
    );

    thisPageInitiatedActionRef.current = true;
    setIsCreating(true);
    onChangeIsUpdating(true);

    const campaign = {
      ...data,
      status: statusCampaign,
    };

    let response = await dispatch(
      startCreateAdsCampaign({ ...campaign, campaignID })
    );

    setIsCreating(false);
    onChangeIsUpdating(false);

    if (response.ok) {
      dispatch(
        updateNotification(campaignID, {
          status: ALERTS_ASYNC_STATUS.SUCCESS,
          message: t(PUBLISHING_ALERT_SUCCESS_TITLE),
          progress: 100,
          isCreating: false,
        })
      );

      await onClearPreloadedChatAndDeleteReport();

      const campaign = response.campaign;
      reset(campaign);
      await waitDelay(500);
      reset(getValues());

      dispatch(checkAndShowNpsForm(NPS_RATING_ACTION_PUBLISH));
    } else if (response.code === ERROR_PROCESSING_CAMPAIGNS) {
      dispatch(
        updateNotification(campaignID, {
          currentCampaign: response.campaign,
          status: ALERTS_ASYNC_STATUS.ERROR,
          message: t(PUBLISHING_ALERT_ERROR_TITLE),
          progress: 100,
          isCreating: false,
          failedCampaigns: response?.failedCampaigns,
          errorsCampaigns: response?.errors,
        })
      );

      reset(response.campaign);
    } else {
      dispatch(removeNotification(campaignID));
    }

    onChangeSectionSelected(sectionSelected);
  };

  const onSaveCampaign = async () => {
    const isValid = await trigger();

    if (!isValid) {
      const errorIndexes = findFirstErrorIndex(errors);

      if (errorIndexes.platform) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          adGroupID: errorIndexes.adGroupID,
          adID: errorIndexes.adID,
          assetsGroupID: errorIndexes.assetsGroupID,
        });
      }

      if (errors.language || errors.locations) {
        onChangeIsForcedSetupPage(true);
        onChangeSectionSelected({
          platform: undefined,
          adGroupID: undefined,
          adID: undefined,
          from: "addPlatforms",
        });
      }
      return;
    }

    // Validar URLs de YouTube inmediatamente después del trigger
    setIsValidatingYoutube(true);
    let areYoutubeUrlsValid = true;
    try {
      areYoutubeUrlsValid = await validateYoutubeUrls();
    } finally {
      setIsValidatingYoutube(false);
    }
    if (!areYoutubeUrlsValid) {
      const errorIndexes = findFirstErrorIndex(errors);
      if (errorIndexes.assetsGroupID) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          assetsGroupID: errorIndexes.assetsGroupID,
        });
      } else if (errorIndexes.adGroupID) {
        onChangeSectionSelected({
          platform: errorIndexes.platform,
          adGroupID: errorIndexes.adGroupID,
        });
      }
      return;
    }

    const data = getValues();

    const canPublish = await confirmPublishWithoutApproval(
      BUTTON_SAVE_AND_PUBLISH
    );
    if (!canPublish) {
      return;
    }

    const previewBudgets = getPreviewAlertBudgets({
      campaign: data,
      dispatch,
      mode: "update",
    });

    if (previewBudgets.length > 0) {
      const result = await ConfirmAlert({
        confirmButtonText: t(BUTTON_SAVE_AND_PUBLISH),
        cancelButtonText: t(BUTTON_EDIT_BUDGET),
        html: (
          <ContainerBudgetAlert
            campaign={data}
            dispatch={dispatch}
            mode="update"
          />
        ),
      });

      if (!result.isConfirmed) {
        return;
      }
    }
    const objectUpdate = getCampaignUpdatedByStatus({
      campaign: data,
      status: getValues("states.general"),
      target: "general",
    });

    thisPageInitiatedActionRef.current = true;
    setIsCreating(true);
    onChangeIsUpdating(true);

    dispatch(
      checkAndAddPublishingCampaign({
        campaignID,
        isCreating: true,
        status: ALERTS_ASYNC_STATUS.LOADING,
        message: t(PUBLISHING_ALERT_TITLE),
        progress: 0,
        currentCampaign: getValues(),
        buttonAction: BUTTON_SAVE_AND_PUBLISH,
      })
    );

    const response = await dispatch(
      startSaveAdsCampaign({
        campaign: objectUpdate,
        campaignID,
      })
    );

    setIsCreating(false);
    onChangeIsUpdating(false);

    if (response.ok) {
      dispatch(
        updateNotification(campaignID, {
          status: ALERTS_ASYNC_STATUS.SUCCESS,
          message: t(PUBLISHING_ALERT_SUCCESS_TITLE),
          progress: 100,
          isCreating: false,
        })
      );

      await onClearPreloadedChatAndDeleteReport();

      reset(response.campaign);
      await waitDelay(500);
      reset(getValues());
    } else if (response.code === ERROR_PROCESSING_CAMPAIGNS) {
      await dispatch(
        startSaveDraftCampaign({
          campaignID,
          campaign: response?.campaign,
        })
      );
      dispatch(
        updateNotification(campaignID, {
          currentCampaign: response.campaign,
          status: ALERTS_ASYNC_STATUS.ERROR,
          message: t(PUBLISHING_ALERT_ERROR_TITLE),
          progress: 100,
          isCreating: false,
          failedCampaigns: response?.failedCampaigns,
          errorsCampaigns: response?.errors,
        })
      );

      reset(response.campaign);
    } else {
      dispatch(removeNotification(campaignID));
    }
    onChangeSectionSelected(sectionSelected);
  };

  const getShowSaveChangesButton = () => {
    return hasSomePlatformDraft && !isGeneralCampaignIncompatible;
  };
  const getShowPublishCampaignButton = () => {
    return hasSomePlatformDraft && !isGeneralCampaignIncompatible;
  };
  const getShowPublishChangesButton = () => {
    return !hasSomePlatformDraft && !isGeneralCampaignIncompatible;
  };

  const getIsCurrentSelectionIncompatible = () => {
    const { platform } = sectionSelected;
    if (!platform) {
      return false;
    }

    if (getValues(`platformsData.${platform}.isIncompatible`)) {
      return true;
    }

    return false;
  };

  const hideBottomBarActions =
    isGeneralCampaignIncompatible || getIsCurrentSelectionIncompatible();

  // Check if there's an active notification for this campaign when component mounts
  // This handles the case where user navigates away and comes back while action is still running
  useEffect(() => {
    if (!campaignID) return;

    const activeNotification = notifications.find(
      (notification) =>
        notification.campaignID === campaignID &&
        (notification.status === ALERTS_ASYNC_STATUS.LOADING ||
          notification.status === ALERTS_ASYNC_STATUS.GENERATING)
    );

    if (activeNotification) {
      // If there's an active notification for this campaign, mark that this page initiated it
      // This prevents reload when the action finishes
      thisPageInitiatedActionRef.current = true;
    }
    //eslint-disable-next-line
  }, [campaignID, notifications]);

  useEffect(() => {
    // If the campaignActionStatus is finished and this page did not start the action, reload the page
    if (
      !campaignActionStatus &&
      lastCampaignActionStatus.current &&
      !thisPageInitiatedActionRef.current
    ) {
      window.location.reload();
    }

    // Reset the ref when the action status changes to null/undefined (action finished)
    if (!campaignActionStatus) {
      thisPageInitiatedActionRef.current = false;
    }

    lastCampaignActionStatus.current = campaignActionStatus;

    //eslint-disable-next-line
  }, [campaignActionStatus]);

  if (!canEditCampaign || hideBottomBarActions) {
    return null;
  }

  const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;
  return (
    <Box
      sx={{
        width: "100%",
        borderTop: `1px solid ${INPUT_COLOR_BORDER}`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          height: 88,
          width: "100%",
        }}
      >
        <Box sx={{ flex: 1 }} />

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            gap: 1,
          }}
        >
          {getShowSaveChangesButton() && (
            <Button
              tooltip={tooltipActionStatus}
              disabled={
                isCampaignExecutingAction ||
                isCreating ||
                isValidatingIfNeedRenderMedia ||
                isGenerating ||
                isUpdating ||
                isSyncingData ||
                isValidatingYoutube
              }
              loading={isSaving || isCreating || isValidatingYoutube}
              type="button"
              color="secondary"
              onClick={onSaveDraftCampaign}
              sx={{
                minWidth: "max-content",
                animation: isDirty ? `${blink} 1s infinite` : "none",
              }}
            >
              {t(BUTTON_SAVE_CHANGES)}
            </Button>
          )}
          {getShowPublishCampaignButton() && (
            <Button
              id="publish-campaign-button"
              tooltip={tooltipActionStatus}
              disabled={
                isSaving ||
                isGenerating ||
                isUpdating ||
                isSyncingData ||
                isCampaignExecutingAction ||
                isValidatingYoutube ||
                isDemoAdvertiser
              }
              onClick={onCreateCampaign}
              loading={
                isCreating ||
                isValidatingIfNeedRenderMedia ||
                isValidatingYoutube
              }
              type="button"
              color="primary"
              sx={{
                minWidth: "max-content",
                px: 3,
              }}
            >
              {t(BUTTON_PUBLISH_CAMPAIGN)}
            </Button>
          )}
          {getShowPublishChangesButton() && (
            <Button
              id="save-and-publish-button"
              tooltip={tooltipActionStatus}
              disabled={
                isSaving ||
                isGenerating ||
                isUpdating ||
                isSyncingData ||
                isCampaignExecutingAction ||
                isValidatingYoutube ||
                isDemoAdvertiser
              }
              onClick={onSaveCampaign}
              loading={isCreating || isValidatingYoutube}
              type="button"
              color="primary"
              sx={{
                minWidth: "max-content",
                px: 3,
                animation: isDirty ? `${blink} 1s infinite` : "none",
              }}
            >
              {t(BUTTON_SAVE_AND_PUBLISH)}
            </Button>
          )}
        </Box>
      </Box>

      {modalConnectAccountsOpen && (
        <ModalConnectAccounts
          modalOpen={modalConnectAccountsOpen}
          onCloseModal={() => setModalConnectAccountsOpen(false)}
          platforms={platforms}
          onCallbackChangeIntegration={({
            platform,
            integrationID,
            adAccountID,
          }) => {
            setValue(`platformsData.${platform}.integrationID`, integrationID);
            setValue(`platformsData.${platform}.adAccountID`, adAccountID);
          }}
        />
      )}
    </Box>
  );
};

export default BottomBar;
